import { useEffect, useState } from 'react';
import { fetchBankStatus } from 'api/raw-banks';
import { releaseTime, useBankRaw } from './useBankRaw';
import styles from 'styles/modules/RawBank.module.scss';

const BLOCKED = {
    limit: 'You already hold two banked Raws. Bank another when one ends.',
    banked_before:
        'You have banked this Raw before, so it can’t be banked again.',
    exclusive: 'This Raw isn’t open to bank yet.',
};

// The journalist's view of Bank on an alert page that is a Raw.
const RawBank = ({ alertId }) => {
    const confirmBank = useBankRaw();
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);

    const load = () =>
        fetchBankStatus(alertId)
            .then(setStatus)
            .catch(() => setStatus(null));

    useEffect(() => {
        load();
    }, [alertId]);

    if (!status?.isRaw) return null;

    const bank = () =>
        confirmBank(alertId, {
            onBanked: () => {
                setError(null);
                load();
            },
            onError: setError,
        });

    return (
        <section className={styles.rawBank}>
            {status.bankedByMe ? (
                <p className={styles.banked} role="status">
                    Banked by you, releases at{' '}
                    {releaseTime(status.bankedByMe.releasesAt)}. It&rsquo;s out
                    of the Newspage archive until then; the alert page stays
                    public.
                </p>
            ) : status.bankedByOther ? (
                <p className={styles.note}>
                    Another journalist is writing this up. It&rsquo;s back in
                    the archive at{' '}
                    {releaseTime(status.bankedByOther.releasesAt)}.
                </p>
            ) : (
                <>
                    <button
                        type="button"
                        className={styles.button}
                        onClick={bank}
                        disabled={!status.canBank}
                        aria-describedby={
                            status.blocked ? 'raw-bank-blocked' : undefined
                        }
                    >
                        Bank this Raw for 24 hours
                    </button>
                    {status.blocked && (
                        <p id="raw-bank-blocked" className={styles.note}>
                            {BLOCKED[status.blocked]}
                        </p>
                    )}
                </>
            )}
            {error && <p className={styles.error}>{error}</p>}
        </section>
    );
};

export default RawBank;
